import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import {OrderService} from './Services/order.service';
import {MessageService} from './Services/message.service';
import {HttpErrorHandler} from './Services/http-error-handler.service';
import {RoomService} from './Services/room.service';
import {HttpClientModule} from '@angular/common/http';
import {ZoneService} from './Services/zone.service';
import { AddImageComponent } from './Components/add-image/add-image.component';
import {FormsModule} from '@angular/forms';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { ToastsContainerComponent } from './Components/toasts-container/toasts-container.component';
import {ToastsBootstrapService} from './Services/toasts-bootstrap.service';
import {NgbToastModule} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './Components/confirmation-dialog/confirmation-dialog.component';
import {FileService} from './Services/file.service';
import {BuildingService} from './Services/building.service';
import { LoadingSpinnerComponent } from './Components/loading-spinner/loading-spinner.component';
import {EquipementService} from './Services/equipement.service';
import {IndicatorService} from './Services/indicator.service';
import { InfoSuccessComponent } from './Components/info-success/info-success.component';
import { InfoProblemComponent } from './Components/info-problem/info-problem.component';
import {InfoStatusService} from './Services/info-status.service';
import {HouseMaidsService} from './Services/house-maids.service';
import {CheckInService} from './Services/check-in.service';
import {UtilsService} from './Services/utils.service';
import {GHouseMaidService} from './Services/ghouse-maid.service';
import {InterventionService} from './Services/intervention.service';
import {InterventionInstanceService} from './Services/intervention-instance.service';
import {UserService} from './Services/user.service';
import { SideBarSearchFilterPipe } from './Pipes/side-bar-search-filter.pipe';
import { SpinnerComponent } from './Components/spinner/spinner.component';
import { NoResultFoundComponent } from './Components/no-result-found/no-result-found.component';

const SERVICES = [
    OrderService,
    MessageService,
    HttpErrorHandler,
    RoomService,
    ZoneService,
    BuildingService,
    FileService,
    ToastsBootstrapService,
    EquipementService,
    IndicatorService,
    InfoStatusService,
    HouseMaidsService,
    CheckInService,
    UtilsService,
    GHouseMaidService,
    InterventionService,
    InterventionInstanceService,
    UserService,
]

@NgModule({
  declarations: [
    AddImageComponent,
    ToastsContainerComponent, 
    ConfirmationDialogComponent, 
    LoadingSpinnerComponent, 
    InfoSuccessComponent, 
    InfoProblemComponent,
    SideBarSearchFilterPipe,
    NoResultFoundComponent,
  ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        MatCarouselModule.forRoot(),
        NgbToastModule,
    ],
  providers: [
      ...SERVICES
  ],
    exports: [
        ToastsContainerComponent,
        LoadingSpinnerComponent,
        SideBarSearchFilterPipe
    ],
    bootstrap:[
        LoadingSpinnerComponent
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
      return {
        ngModule: SharedModule,
      };
    }
  }
